module.exports = __webpack_public_path__ + "static/media/IMG_8652.8cfa94b7.jpg";